import { Component, Input } from '@angular/core';
import { NavLink } from '../../models/navlink.model';

export function checkClick(nav: NavLink) {
  if (nav && nav.onClick) {
    return nav.onClick;
  }
  return () => { };
}

@Component({
  selector: 'inc-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  checkClick = checkClick;

  @Input() navTitle = 'Inclouded';
  @Input() navList: NavLink[];

  constructor() { }

}
